enum SERVICE_WORKER_ACTIONS {
    ENABLE_SERVICE_WORKER = 'enable-service-worker',
    DISABLE_SERVICE_WORKER = 'disable-service-worker',
    INVALIDATE_INFO_CALL_CACHE = 'invalidate-info-cache',
}

export const enableServiceWorker = () => {
    window.postMessage(
        { type: SERVICE_WORKER_ACTIONS.ENABLE_SERVICE_WORKER },
        window.location.origin,
    );
};

export const disableServiceWorker = () => {
    window.postMessage(
        { type: SERVICE_WORKER_ACTIONS.DISABLE_SERVICE_WORKER },
        window.location.origin,
    );
};

export const invalidateSessionInfoCallCache = () => {
    window.postMessage(
        { type: SERVICE_WORKER_ACTIONS.INVALIDATE_INFO_CALL_CACHE },
        window.location.origin,
    );
};
